export const SYNC_PATH = 'sync';
export const REDIRECT_PATH = `/engage/${SYNC_PATH}`;
export const CALENDAR_SYNC_API_BASE = `/api/calendars-sync`;
export const CALENDAR_SYNC_FILTERS_KEY = `events.sync.filters`;
export const CALENDAR_SYNC_TROUBLESHOOT_FILTERS_KEY = `events.sync.troubleshoot.filters`;
export const CALENDAR_SYNC_COMMON_KEY = 'calendar-sync-common';
